import { inject, Provider } from '@angular/core';
import { SkSelectConfig } from '@ngx-strakit/cdk/controls/select';
import { TranslateService } from '@ngx-translate/core';

export function provideSkSelectConfig(options: Partial<SkSelectConfig> = {}): Provider {
  return {
    provide: SkSelectConfig,
    useFactory: (): SkSelectConfig => {
      const translateService = inject(TranslateService);

      const {
        typeToSearchText = 'label.TypeToSearch',
        notFoundText = 'label.NoResultsFound',
        addTagText = 'label.AddNew',
        clearAllText = 'label.ClearAll',
      } = options;

      return {
        ...new SkSelectConfig(),
        typeToSearchText: translateService.instant(typeToSearchText),
        notFoundText: translateService.instant(notFoundText),
        addTagText: translateService.instant(addTagText),
        clearAllText: translateService.instant(clearAllText),
        ...options,
      };
    },
  };
}

